export const MessageComponentKey = {
	WITH_BUTTONS: 'with-buttons',
} as const;
